import React from "react";
import {Button, ButtonState} from "../../../../elements/button/Button";
import {ValidatedForm, FormContext} from "../../../../elements/validator/validatedForm/ValidatedForm";
import {BotType, UpdateBotToolSettingsRequest} from "../../../../../api/generated";
import {VehicleSearchSettings} from "./components/VehicleSearchSettings";
import {RequestSettings} from "./components/RequestSettings";
import {FinanceSettings} from "./components/FinanceSettings";
import {ReservationConfiguration} from "./components/ReservationConfiguration";
import {PartExchangeRules} from "./components/PartExchangeRules";
import styles from "./ToolSettingsForm.module.css";
import {RequestStatus} from "../../../../../api/apiConfiguration";

interface ToolSettingsFormProps {
    hasUnsavedChanges: boolean;
    onSave: () => Promise<void>;
    onDiscard: () => void;
    botType: BotType;
    updateStatus: RequestStatus;
}

export const ToolSettingsForm: React.FC<ToolSettingsFormProps> = ({
                                                                       hasUnsavedChanges,
                                                                       onSave,
                                                                       onDiscard,
                                                                       botType,
                                                                       updateStatus
                                                                   }) => {

    return (
        <ValidatedForm<UpdateBotToolSettingsRequest> submitForm={onSave}>
            {(formCtx: FormContext<UpdateBotToolSettingsRequest>) => {
                const {updateValidationStatus, getMessage, formDisabled, onSubmitClick} = formCtx;

                const getMessageWrapper = (f: string): string => {
                    return getMessage(f as keyof UpdateBotToolSettingsRequest) || '';
                };

                return (
                    <div className={styles.wrapper}>
                        <div className={styles.sections}>
                            <VehicleSearchSettings botType={botType}/>

                            <RequestSettings botType={botType} />

                            <FinanceSettings
                                botType={botType}
                                updateValidationStatus={updateValidationStatus}
                                getMessageWrapper={getMessageWrapper}
                            />

                            <PartExchangeRules
                                botType={botType}
                                updateValidationStatus={updateValidationStatus}
                                getMessageWrapper={getMessageWrapper}
                            />

                            <ReservationConfiguration
                                botType={botType}
                                updateValidationStatus={updateValidationStatus}
                                getMessageWrapper={getMessageWrapper}
                            />
                        </div>

                        <div className={styles.buttonContainer}>
                            <Button
                                title="Discard Changes"
                                state={hasUnsavedChanges ? ButtonState.SECONDARY : ButtonState.DISABLED}
                                handleClick={onDiscard}
                            />
                            <Button
                                title="Save Changes"
                                state={formDisabled || !hasUnsavedChanges || updateStatus === RequestStatus.PENDING
                                    ? ButtonState.DISABLED
                                    : ButtonState.PRIMARY}
                                handleClick={onSubmitClick}
                            />
                        </div>
                    </div>
                );
            }}
        </ValidatedForm>
    );
};
